import { StudyDesign_OPTIONS } from "api/modules/common.option";
import { getLabelFromValue } from "helpers/constant";
import { Badge, Button } from "reactstrap";

 export const workflowColumns: any = (navigate:any) => [
    { key: "studycode", label: "Study Code", type: "link", onClick: (row: any) => navigate(`/qaqc/review/${row.studyid || row.id}`) },
    { key: "studytitle", label: "Study Title" },
    { key: "sponsorname", label: "Sponsor" },
    { 
       key: "studydesign", 
       label: "Study Design",
       cell: (row: any) => getLabelFromValue(StudyDesign_OPTIONS, row.studydesign) || row.studydesign 
    },
    {
      key: "status",
      label: "Review Status",
      cell: (row: any) => {
        const idStr = row.studyid ? row.studyid.toString() : "0";
        const hash = idStr.charCodeAt(0) % 3;

        let status = "Pending QC";
        if (hash === 1) status = "Pending QA";
        if (hash === 2) status = "Queries Raised";

        let color = "warning";
        if (status === "Pending QA") color = "info";
        else if (status === "Queries Raised") color = "danger";
        
        return <Badge color={color} className="px-3 py-1 bg-opacity-10 text-dark rounded-pill fw-medium" style={{ border: `1px solid var(--bs-${color})` }}>{status}</Badge>;
      }
    },
    {
      key: "actions",
      label: "Actions",
      textCenter: true,
      cell: (row: any) => (
        <Button size="sm" color="primary" className="rounded-pill px-3 d-flex align-items-center gap-1 fw-medium m-auto" outline onClick={() => navigate(`/qaqc/review/${row.studyid || row.id}`)}>
          <i className="ri-file-search-line"></i> Start Review
        </Button>
      )
    }
  ];